import { Box, CircularProgress, CssBaseline } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import MaintenanceBanner from "./Components/Layout/MaintenanceBanner";
import { useAppDispatch, useAppSelector } from "./Redux/hooks";
import { fetchActiveMaintenance } from "./Redux/reducers/maintenanceSlice";

function App() {
  const dispatch = useAppDispatch();
  const isUserAuthenticated = useAppSelector(
    (state) => state.user.isUserAuthenticated
  );

  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    if (!isUserAuthenticated) return;
    dispatch(fetchActiveMaintenance());
    const id = setInterval(
      () => dispatch(fetchActiveMaintenance()),
      30 * 60 * 1000
    );
    return () => clearInterval(id);
  }, [dispatch, isUserAuthenticated]);

  return (
    <div className="app-main">
      <CssBaseline />
      {isUserAuthenticated && <MaintenanceBanner />}

      <RouterProvider
        router={routes}
        fallbackElement={
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        }
      />
      <ToastContainer />
    </div>
  );
}

export default App;
